import { AbstractFilterModel } from "@gipi-pages/abstract/models/abstract-filter.model";

export class ClientClassificationFilterDTO extends AbstractFilterModel { }
